import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  query,
  where,
  updateDoc
} from "firebase/firestore";
import { db } from "../firebase";
import { Toast } from "bootstrap";
import Sidebar from "../components/Sidebar";
import { FaTrash, FaEdit, FaPlus, FaSave } from "react-icons/fa";

export default function MarquesModelesManager() {
  const [marques, setMarques] = useState([]);
  const [modelesParMarque, setModelesParMarque] = useState({});
  const [selectedMarque, setSelectedMarque] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const toastRef = React.useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [newMarque, setNewMarque] = useState("");
  const [newModele, setNewModele] = useState("");
  const [ficheTechnique, setFicheTechnique] = useState({ moteur: "", carburant: "", transmission: "" });
  const [editedMarqueNom, setEditedMarqueNom] = useState("");
  const [editedModeles, setEditedModeles] = useState({});
  const [modeleToDelete, setModeleToDelete] = useState(null);

  const fetchData = async () => {
    const snapshot = await getDocs(collection(db, "marques"));
    const allMarques = await Promise.all(
      snapshot.docs.map(async (docSnap) => {
        const marqueData = { id: docSnap.id, ...docSnap.data() };
        const modelesSnap = await getDocs(collection(db, `marques/${docSnap.id}/modeles`));
        const modeles = modelesSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
        return { ...marqueData, modeles };
      })
    );
    setMarques(allMarques);
    const dict = {};
    allMarques.forEach((m) => (dict[m.nom.toLowerCase()] = m.modeles));
    setModelesParMarque(dict);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const showToast = (type = "success") => {
    setToastType(type);
    setTimeout(() => {
      if (toastRef.current) {
        toastRef.current.classList.remove("show");
      }
    }, 4000);
    if (toastRef.current) {
      const toast = new Toast(toastRef.current, { delay: 3000 });
      toast.show();
    }
  };

  const handleUpdateMarque = async () => {
    if (!selectedMarque || !editedMarqueNom.trim()) return;
    await updateDoc(doc(db, "marques", selectedMarque.id), { nom: editedMarqueNom.trim() });
    setToastMessage("Marque modifiée avec succès");
    showToast("success");
    fetchData();
  };

  const handleUpdateModele = async (modeleId) => {
    if (!editedModeles[modeleId]) return;
    await updateDoc(doc(db, `marques/${selectedMarque.id}/modeles`, modeleId), {
      nom: editedModeles[modeleId].nom,
      ficheTechnique: editedModeles[modeleId].ficheTechnique
    });
    setToastMessage("Modèle mis à jour");
    showToast("success");
    setShowModal(false);
    fetchData();
  };

  const handleDeleteModel = async () => {
    if (!selectedMarque || !modeleToDelete) return;
    await deleteDoc(doc(db, `marques/${selectedMarque.id}/modeles`, modeleToDelete.id));
    setToastMessage("Modèle supprimé avec succès");
    showToast("success");
    setModeleToDelete(null);
    fetchData();
  };

  const ConfirmDeleteModal = () => (
    <div className="modal show fade d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Confirmer la suppression</h5>
            <button type="button" className="btn-close" onClick={() => setModeleToDelete(null)}></button>
          </div>
          <div className="modal-body">
            <p>Voulez-vous vraiment supprimer le modèle "{modeleToDelete?.nom}" ?</p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={() => setModeleToDelete(null)}>Annuler</button>
            <button className="btn btn-danger" onClick={handleDeleteModel}>Supprimer</button>
          </div>
        </div>
      </div>
    </div>
  );


  return (
    <div className="d-flex flex-column flex-md-row">
      <Sidebar />
      <main className="flex-grow-1 p-3" style={{ marginLeft: "250px" }} id="mainContent">
        <div className="container-fluid px-2 px-md-4 py-3">
          <div className="mb-4">
            <h3>Gestion des Marques</h3>
            <input
              className="form-control mb-2"
              placeholder="Nouvelle marque"
              value={newMarque}
              onChange={(e) => setNewMarque(e.target.value)}
            />
            <button className="btn btn-success" onClick={async () => {
              if (!newMarque.trim()) return;
              await addDoc(collection(db, "marques"), { nom: newMarque.trim() });
              setNewMarque("");
              fetchData();
              setToastMessage("Marque ajoutée avec succès");
              showToast();
            }}>
              <FaPlus /> Ajouter
            </button>
          </div>

          <div className="row g-3">
            {marques.map((marque) => (
              <div className="col-md-4" key={marque.id}>
                <div className="card">
                  <div className="card-body">
                    <h5>{marque.nom}</h5>
                    <button className="btn btn-primary me-2" onClick={() => {
                      setSelectedMarque(marque);
                      setEditedMarqueNom(marque.nom);
                      setShowModal(true);
                    }}><FaEdit /></button>
                    <button className="btn btn-danger" onClick={async () => {
                      await deleteDoc(doc(db, "marques", marque.id));
                      fetchData();
                    }}><FaTrash /></button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {showModal && selectedMarque && (
            <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Modèles de {selectedMarque.nom}</h5>
                    <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                  </div>
                  <div className="modal-body">
                    <input
                      className="form-control mb-3"
                      value={editedMarqueNom}
                      onChange={(e) => setEditedMarqueNom(e.target.value)}
                    />
                    <button className="btn btn-success mb-4" onClick={handleUpdateMarque}>
                      <FaSave /> Sauvegarder Marque
                    </button>

                    <div className="input-group mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Nom du modèle"
                        value={newModele}
                        onChange={(e) => setNewModele(e.target.value)}
                      />
                      <button className="btn btn-primary" onClick={async () => {
                        const modeleRef = collection(db, `marques/${selectedMarque.id}/modeles`);
                        const checkQuery = query(modeleRef, where("nom", "==", newModele.trim()));
                        const existing = await getDocs(checkQuery);
                        if (!existing.empty) {
                          setToastMessage("Ce modèle existe déjà pour cette marque.");
                          showToast("danger");
                          return;
                        }
                        await addDoc(modeleRef, {
                          nom: newModele.trim(),
                          ficheTechnique
                        });
                        setNewModele("");
                        setFicheTechnique({ moteur: "", carburant: "", transmission: "" });
                        setToastMessage("Modèle ajouté avec succès");
                        showToast("success");
                        fetchData();
                      }}>
                        <FaPlus />
                      </button>
                    </div>

                    <div className="row g-2 mb-3">
                      <div className="col">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Moteur"
                          value={ficheTechnique.moteur}
                          onChange={(e) => setFicheTechnique({ ...ficheTechnique, moteur: e.target.value })}
                        />
                      </div>
                      <div className="col">
                        <select
                          className="form-control"
                          value={ficheTechnique.carburant}
                          onChange={(e) => setFicheTechnique({ ...ficheTechnique, carburant: e.target.value })}
                        >
                          <option value="">Carburant</option>
                          <option value="Essence">Essence</option>
                          <option value="Diesel">Diesel</option>
                          <option value="Hybride">Hybride</option>
                          <option value="Électrique">Électrique</option>
                        </select>
                      </div>
                      <div className="col">
                        <select
                          className="form-control"
                          value={ficheTechnique.transmission}
                          onChange={(e) => setFicheTechnique({ ...ficheTechnique, transmission: e.target.value })}
                        >
                          <option value="">Transmission</option>
                          <option value="Manuelle">Manuelle</option>
                          <option value="Automatique">Automatique</option>
                        </select>
                      </div>
                    </div>

                    <ul className="list-group">
                      {(modelesParMarque[selectedMarque.nom.toLowerCase()] || []).map((modele) => (
                        <li key={modele.id} className="list-group-item">
                          <input
                            type="text"
                            className="form-control mb-1"
                            defaultValue={modele.nom}
                            onChange={(e) => setEditedModeles({
                              ...editedModeles,
                              [modele.id]: {
                                ...editedModeles[modele.id],
                                nom: e.target.value,
                                ficheTechnique: editedModeles[modele.id]?.ficheTechnique || modele.ficheTechnique
                              }
                            })}
                          />
                          <div className="row g-1 mb-2">
                            <div className="col">
                              <input
                                type="text"
                                className="form-control"
                                defaultValue={modele.ficheTechnique?.moteur || ""}
                                placeholder="Moteur"
                                onChange={(e) => setEditedModeles({
                                  ...editedModeles,
                                  [modele.id]: {
                                    ...editedModeles[modele.id],
                                    nom: editedModeles[modele.id]?.nom || modele.nom,
                                    ficheTechnique: {
                                      ...editedModeles[modele.id]?.ficheTechnique,
                                      moteur: e.target.value
                                    }
                                  }
                                })}
                              />
                            </div>
                            <div className="col">
                              <select
                                className="form-control"
                                defaultValue={modele.ficheTechnique?.carburant || ""}
                                onChange={(e) => setEditedModeles({
                                  ...editedModeles,
                                  [modele.id]: {
                                    ...editedModeles[modele.id],
                                    nom: editedModeles[modele.id]?.nom || modele.nom,
                                    ficheTechnique: {
                                      ...editedModeles[modele.id]?.ficheTechnique,
                                      carburant: e.target.value
                                    }
                                  }
                                })}
                              >
                                <option value="">Carburant</option>
                                <option value="Essence">Essence</option>
                                <option value="Diesel">Diesel</option>
                                <option value="Hybride">Hybride</option>
                                <option value="Électrique">Électrique</option>
                              </select>
                            </div>
                            <div className="col">
                              <select
                                className="form-control"
                                defaultValue={modele.ficheTechnique?.transmission || ""}
                                onChange={(e) => setEditedModeles({
                                  ...editedModeles,
                                  [modele.id]: {
                                    ...editedModeles[modele.id],
                                    nom: editedModeles[modele.id]?.nom || modele.nom,
                                    ficheTechnique: {
                                      ...editedModeles[modele.id]?.ficheTechnique,
                                      transmission: e.target.value
                                    }
                                  }
                                })}
                              >
                                <option value="">Transmission</option>
                                <option value="Manuelle">Manuelle</option>
                                <option value="Automatique">Automatique</option>
                              </select>
                            </div>
                          </div>
                          <div className="d-flex justify-content-end gap-2">
                            <button className="btn btn-sm btn-success" onClick={() => handleUpdateModele(modele.id)}><FaSave /></button>
                            <button className="btn btn-sm btn-outline-danger" onClick={() => setModeleToDelete(modele)}><FaTrash /></button>
                          </div>
                        </li>
                      ))}
                    </ul>

                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Fermer</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div
            ref={toastRef}
            className={`toast position-fixed bottom-0 end-0 m-3 text-white bg-${toastType}`}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{ zIndex: 1055 }}
          >
            <div className="toast-header">
              <strong className="me-auto">
                {toastType === "danger" ? "Erreur" : "Succès"}
              </strong>
              <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
            <div className="toast-body">{toastMessage}</div>
          </div>
        </div>
      </main>
      {modeleToDelete && <ConfirmDeleteModal />}
    </div>
  );
}
